// 教学视频
import http from "@/jslibs/axios/http";

// 列表
export const page = (data) => http.post("/web/contentManager/getTeachVideoList", data);

// 新增
export const add = (data) => http.post("/web/contentManager/addTeachVideo", data);

// 删除
export const del = (data) => http.post("/web/contentManager/deleteTeachVideo", data);

// 详情
export const detail = (data) => http.post("/web/contentManager/getTeachVideoDetail", data);

// 编辑 
export const edit = (data) => http.post("/web/contentManager/updateTeachVideo", data);